import { CategoriaFaq } from '@hm_app/@core/models/info';
import { Struttura } from '@hm_app/@core/models/struttura';
import { Injectable, Type } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class FaqCategorieService {

    // Observable sources
    private categoriaFaq = new BehaviorSubject<CategoriaFaq>(null);

    // Observable streams
    categoriaFaqObservable = this.categoriaFaq.asObservable();

    // Service message commands
    passCategoriaFaq(categoriaFaq: CategoriaFaq) {
        this.categoriaFaq.next(categoriaFaq);
    }
}
